import workspaceQuery from '../../../graphql/queries/sales/EdiConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/EdiConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/EdiConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/EdiConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/EdiConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/EdiConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const EdiConfiguration: EntityType = {
  type: 'EdiConfiguration',
  title: 'Edi and Xedi Configurations',
  formTitle: 'Edi Configuration',
  formUrl: '/Sales/Channel/EdiConfig/Details/',
  workspaceUrl: '/Sales/Channel/EdiConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_EDI_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default EdiConfiguration;
